import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { createStore, applyMiddleware, Store } from "redux"
import { Provider } from "react-redux"
import thunk from "redux-thunk"
import "bootstrap/dist/css/bootstrap.min.css"
import * as Sentry from "@sentry/react"

import reducer from "./redux/reducer"
import "./styles/css/index.css"
import App from "./App"
import { APP_ENV } from "./utils/config"

if (APP_ENV === 'production') {
  Sentry.init({
    dsn: "https://344a29b716025402bb9a7e0cbaa29f26@o4510418243682304.ingest.us.sentry.io/4510418245320704",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    environment: "production"
  })
}

const store: Store<UserState, UserAction> & {
  dispatch: DispatchType
} = createStore(reducer, applyMiddleware(thunk))

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter future={{ v7_startTransition: true }}>
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
)
